import { Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ChangelogPreviewToolbarProps {
  onToggleFullscreen: () => void;
}

export function ChangelogPreviewToolbar({
  onToggleFullscreen,
}: ChangelogPreviewToolbarProps) {
  return (
    <div className="flex h-12 items-center justify-between border-b px-3">
      <span className="text-sm font-medium">미리보기</span>

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={onToggleFullscreen}
              aria-label="전체화면 미리보기"
            >
              <Maximize2 className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>전체화면 미리보기</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
